import {createSelector} from 'reselect';

export const getAllFunds =  (state) => state ? state : {};

export const getAllFundsList = createSelector(
  [getAllFunds],
  (allFunds) => allFunds.allFunds.funds ?? []
);


